/*
 * pdp-facets.js
 * ---------------------------------------------------------------
 * Two hard-coded delays in Dawn's MenuDrawer, removed for the mobile
 * filter drawer only.
 *
 * Opening a filter group runs `setTimeout(..., 100)` before it adds the
 * class that reveals the panel, so every tap buys 100ms of nothing before
 * the animation has even started. Closing one spins
 * `requestAnimationFrame` against a hard-coded 400ms before it will
 * remove the `open` attribute, so going back waits out a slide that has
 * already finished.
 *
 * Neither number is configurable and neither is in CSS, which is why the
 * timings could not be fixed in the stylesheet. Rather than edit
 * global.js -- which the whole site's navigation runs on -- this listens
 * on the capture phase and does the same work first. Dawn's own handler
 * still runs and finds the class already set, which is a no-op.
 *
 * Scoped to `.mobile-facets` throughout. The header menu is untouched.
 * ---------------------------------------------------------------
 */
(function () {
  if (document.documentElement.dataset.pdpFacetSpeed) return;
  document.documentElement.dataset.pdpFacetSpeed = '1';

  /* Open: reveal on the same frame as the tap, not 100ms later. */
  document.addEventListener(
    'click',
    function (event) {
      var summary = event.target.closest && event.target.closest('.mobile-facets__summary');
      if (!summary || !summary.closest('.mobile-facets')) return;

      var details = summary.parentNode;
      if (!details || details.tagName !== 'DETAILS') return;
      if (details.hasAttribute('open')) return; // this tap is closing it

      /* The click has not toggled `open` yet -- that happens as the
         browser's default action, after this listener. One frame later
         the attribute is there and the class can go on. */
      requestAnimationFrame(function () {
        if (!details.hasAttribute('open')) return;
        details.classList.add('menu-opening');
        summary.setAttribute('aria-expanded', 'true');
        var parent = details.closest('.has-submenu');
        if (parent) parent.classList.add('submenu-open');
      });
    },
    true
  );

  /* Close: drop `open` as soon as the fade is done rather than waiting
     out Dawn's 400ms counter. 160ms clears the 140ms opacity transition
     with a frame to spare. */
  document.addEventListener(
    'click',
    function (event) {
      var back = event.target.closest && event.target.closest('.mobile-facets__close-button');
      if (!back || !back.closest('.mobile-facets')) return;

      var details = back.closest('details');
      if (!details) return;

      setTimeout(function () {
        if (!details.classList.contains('menu-opening')) details.removeAttribute('open');
      }, 160);
    },
    true
  );
})();
